import React, { Component } from 'react';
import SelectionPopover from 'react-selection-popover';

import language from '../../assets/languages/language';
import { clearSelection, highlightString } from '../../common/highlightText';
import config from '../../views/config/App_data';
import { renderHTMLContent } from '../../common/function';

export default class HighlightText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopover: false,
      highlights: [],
      question: props.content,
    };
    this.highLightedQuestion = this.props.content;
  }

  setShowPopover = (value) => this.setState({ showPopover: value });

  addHighlightToText = async () => {
    const text = this.getSelectionHtml();
    const { mockId: mock_id, questionId: question_id, testId: test_id } = this.props.params;
    const { ApiServiceProvider } = this.props;
    const res = await ApiServiceProvider['addHighlightedTextService']({
      mock_id,
      question_id,
      test_id,
      text,
    });
    if (res) {
      this.setState({ showPopover: false });
      await this.getHighlightedText();
      clearSelection();
    }
  };

  deleteHighlightFromText = () => {
    const text = this.getSelectionHtml();

    const { highlights } = this;
    const getHighlightedTextData = highlights
      ? highlights.filter((item) => {
        return item.text === text;
      })[0]
      : [];

    this.deleteHighlight(getHighlightedTextData.id);
  };

  getSelectionHtml = () => {
    let html = '';
    if (typeof window.getSelection !== 'undefined') {
      const sel = window.getSelection();
      if (sel.rangeCount) {
        const container = document.createElement('div');
        for (let count = 0, len = sel.rangeCount; count < len; ++count) {
          container.appendChild(sel.getRangeAt(count).cloneContents());
        }
        html = container.innerHTML;
      }
    } else if (typeof document.selection !== 'undefined') {
      if (document.selection.type === 'Text') {
        html = document.selection.createRange().htmlText;
      }
    }
    return html;
  };

  deleteHighlight = async (id) => {
    const { mock_id } = this.props.params;
    const { ApiServiceProvider } = this.props;
    if (id) {
      const result = await ApiServiceProvider['deleteHighlightService']({
        mock_id,
        id,
      });
      if (result) {
        this.setState({ showPopover: false });
        await this.getHighlightedText();
        clearSelection();
      }
    } else {
      return;
    }
  };

  setQuestion = (question) => {
    this.setState({ question });
  };

  getHighlightedText = async () => {
    const { mockId: mock_id, questionId: question_id, testId: test_id } = this.props.params;
    const { ApiServiceProvider } = this.props;
    const resp = await ApiServiceProvider['getHighlightedTextService']({
      mock_id,
      question_id,
      test_id,
    });

    const {
      setQuestion,
      props: { content },
    } = this;

    this.highLightedQuestion = content;
    if (resp.success) {
      if (resp.data.length) {
        this.highlights = resp.data;
        resp.data.forEach((element) => {
          this.highLightedQuestion = highlightString(this.highLightedQuestion, element.text);
        });
      }

      setQuestion(this.highLightedQuestion);
    }
  };

  componentDidMount = async () => {
    this.getHighlightedText();
  };

  componentDidUpdate = async (prevProps) => {
    if (prevProps.content !== this.props.content) this.getHighlightedText();
  };

  render() {
    const { state, setShowPopover } = this;
    const { showPopover, question } = state;

    const text = this.getSelectionHtml();
    const highlighted = `<b style="background-color: yellow" title="highlighted">${text}</b>`;
    const getHighlightedText = this.highLightedQuestion.indexOf(highlighted);

    return (
      <div data-selectable>
        {renderHTMLContent(question, "div", "margin_bottom_40 view_questionhtml bg_blue", { contentEditable: 'false' })}
        <SelectionPopover
          showPopover={showPopover}
          onSelect={() => setShowPopover(true)}
          onDeselect={() => setShowPopover(false)}
        >
          {getHighlightedText === -1 ? (
            <div className='highlight-popover tooltip_wrap'>
              <img
                src={`${config.frontend_url}/img/high-edit-ico.svg`}
                alt='523'
                width='30'
                onClick={() => this.addHighlightToText()}
              />
              <div className='tootip_box'>{language.LC().Click_me_to_highlight}</div>
            </div>
          ) : (
            <div className='highlight-popover tooltip_wrap'>
              <img
                src={`${config.frontend_url}/img/icon_select_text.png`}
                alt='523'
                width='30'
                onClick={() => this.deleteHighlightFromText()}
              />
              <div className='tootip_box'>{language.LC().Click_me_to_unhighlight}</div>
            </div>
          )}
        </SelectionPopover>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/HighlightText.jsx